document.addEventListener("DOMContentLoaded", function () {

  // const myCustomImageUrl = "https://cdn.shopify.com/s/files/1/0796/3610/3406/files/home_page_logo_1.png?v=1780740452";
  // const myCustomImageUrl = "https://cdn.shopify.com/s/files/1/0796/3610/3406/files/Login_Page_Banner.png?v=1780905016";
  const myCustomImageUrl = "https://cdn.shopify.com/s/files/1/0796/3610/3406/files/Login_Page_Banner_1.png?v=1780909495";

  const targetContainer = document.querySelector(".passcode-image-container");
  const targetImg = document.querySelector(".passcode-image-container img");

  function enforceCustomStyles() {

    if (targetImg && targetImg.getAttribute("src") !== myCustomImageUrl) {
      targetImg.src = myCustomImageUrl;
    }
    
    if (targetContainer) {
      targetContainer.style.setProperty("width", "100vw", "important");
      targetContainer.style.setProperty("position", "relative", "important");
      targetContainer.style.setProperty("left", "50%", "important");
      targetContainer.style.setProperty("right", "50%", "important");
      targetContainer.style.setProperty("margin-left", "-50vw", "important");
      targetContainer.style.setProperty("margin-right", "-50vw", "important");
      targetContainer.style.setProperty("margin-bottom", "20px", "important");
    }

    if (targetImg) {
      targetImg.style.setProperty("width", "100%", "important");
      targetImg.style.setProperty("max-width", "100%", "important");
      targetImg.style.setProperty("max-height", "none", "important");
      targetImg.style.setProperty("height", "auto", "important");
      targetImg.style.setProperty("display", "block", "important");
    }
  }

  enforceCustomStyles();

  if (targetContainer && targetImg) {
    const observer = new MutationObserver(function (mutations) {
      enforceCustomStyles();
    });

    observer.observe(targetContainer, { attributes: true, attributeFilter: ["style", "class"] });
    observer.observe(targetImg, { attributes: true, attributeFilter: ["src", "style"] });
  }
});
